
<template>
  <blockquote class="com-news-source">
    <span>文章来源: </span>
    <span class="news-link" @click="linkToSource">{{dataInfo.source}}</span>
  </blockquote>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
export default {
  mixins: [CptMixin],
  methods: {
    linkToSource () {
      console.log(this.dataInfo.url);
    }
  }
}
</script>

<style lang="less">
.com-news-source {
  margin: 10px 0 0;
  padding-left: 15px;
  font-size: 14px;
  border-left: 4px solid #e1e6eb;
  color: #8c96a0;
  line-height: 20px;
  .news-link {
    font-size: 14px;
    line-height: 20px;
    color: #64696E;
    word-break: break-all;
  }
}
</style>